module.exports = __webpack_public_path__ + "static/media/icons_Bilan Spondylarthrite.d527b5d9.svg";